import {Card} from "reactstrap";
import AppLink from "../AppLink";
import { useAppNavigate } from "../../../utils/link.utils";
import moment from "moment";



export function HomeSessionCard({id, name, description, timestamp, url = null, imageUrl = null, status = null, noTranscription = false}) {
    if (url === null) {
        url = `/sessions/view?id=${id}`;
    }
    if (imageUrl === null) {
        imageUrl = '/images/video_icon2.png';
    }
    const navigate = useAppNavigate();
    return (
        <Card onClick={() => navigate(url)} style={{ cursor: "pointer" }}>
            <div className="product-box">
                <div className="product-img" style={{ textAlign: 'center' }}>
                    {status && (
                        <span className="ribbon ribbon-primary">
                            {status}
                        </span>
                    )}
                    <img
                        className="img-fluid "
                        src={imageUrl}
                        alt=""
                    />
                    <div className="product-hover">
                        <ul>
                            <li>
                                <AppLink to={url}>
                                    <i
                                        className="icofont icofont-ui-video-play"
                                        onClick={() => {
                                        }}
                                    />
                                </AppLink>
                            </li>
                        </ul>
                    </div>
                    {noTranscription && (
                        <span className="ribbon ribbon-primary ribbon-right ribbon-clip-bottom">
                            Non Trascritto
                        </span>
                    )}
                </div>
                <div className="product-details">
                    <h5>
                        <AppLink to={url}>
                            {name}
                        </AppLink>
                    </h5>
                    <p>{description}</p>
                    <div className="product-price">
                        {moment(new Date(timestamp)).format('DD/MM/YYYY')}
                    </div>
                </div>
            </div>
        </Card>
    )
}
